module.exports = __webpack_public_path__ + "img/Difarmer-quiero-ser-cliente-hasta-la-cima.0d115462.png";